<button class="p-button-rounded secondary" pButton type="button" icon="pi pi-plus" iconPos="left"
    [label]="selected ? 'change color' : 'add color'" (click)="openCreate()"
    [ngStyle]="{background: selected}"></button>

<p-dialog header="choose color" [(visible)]="displayCreate">
    <div class="row my-2">
        <div class="p-field mb-3 w-100">
            <span class="p-float-label p-input-icon-left w-100">
                <i class="pi pi-search"></i>
                <input type="text" pInputText id=search [(ngModel)]="searchStr" (ngModelChange)="onSearch($event)" />
                <label for="search">color</label>
            </span>
        </div>
    </div>
    <div class="row">
        <div *ngFor="let color of filteredColors" class="col-md-2 mb-2" (click)="onColorSelection(color)">
            <div class="justify-content-center d-flex flex-column align-items-center">
                <p class="projul-text mx-1">{{color?.name}}</p>
                <div class="color-circle" [ngStyle]="{background: color.code}"></div>
            </div>
        </div>

        <div class="w-100 text-center" *ngIf="filteredColors.length === 0">
            <i class="pi pi-exclamation-circle"></i>
            <p class="projul-text">no data found</p>
        </div>
    </div>
</p-dialog>